import { ArrowUpRightFromCircle, SquareArrowOutUpRight } from "lucide-react";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

type TriggerVariant = "icon-only" | "icon-with-text" | "text-only";

interface PdfLinkProps {
  documentUrl: string;
  label?: string;
  variant?: TriggerVariant;
  iconSize?: "sm" | "md";
  className?: string;
}

const iconSizeClasses = {
  sm: "size-4",
  md: "size-5",
};

/** Simple styled link to open a PDF in a new tab. Use this in modal contexts where HoverCard preview doesn't work. */
export const PdfLink = ({ documentUrl, label, variant = "icon-with-text", iconSize = "sm", className }: PdfLinkProps) => {
  const renderContent = () => {
    switch (variant) {
      case "icon-only":
        return <SquareArrowOutUpRight size={16} className="cursor-pointer text-blue-600 visited:text-purple-600 dark:text-blue-500" />;
      case "text-only":
        return <span>{label}</span>;
      case "icon-with-text":
      default:
        return (
          <>
            <ArrowUpRightFromCircle className={iconSizeClasses[iconSize]} />
            {label && <span className="ml-1 text-sm">{label}</span>}
          </>
        );
    }
  };

  const defaultClassName =
    variant === "text-only"
      ? "font-medium text-blue-600 hover:underline dark:text-blue-500"
      : "flex items-center text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300";

  return (
    <a href={documentUrl} target="_blank" rel="noreferrer" className={cn(defaultClassName, className)}>
      {renderContent()}
    </a>
  );
};
